import { Observable, of, throwError } from "rxjs";
import { switchMap, mergeMap, map, withLatestFrom, catchError } from "rxjs/operators";
import { fromFetch } from "rxjs/fetch";
import { Location } from "./location";
import { Geocoder } from "./geocoder";
export class HEREGeocoder extends Geocoder {
    _boundingpolygon = []; // = [[47.550900130350776, 7.596061963568179], [47.548048603090535, 7.5914791547311475], [47.549121568841294, 7.5890158949812445], [47.55180872000259, 7.593971057036283], [47.55333588839485, 7.591493476008763], [47.547429946187776, 7.585192113857845], [47.545119584765516, 7.593999699591514]];
    constructor(inputField, config_opt) {
        super(inputField);
        const newConf = config_opt || {};
        this.configure(newConf);
    }
    get query$() {
        const query$ = this.inputSearch$(300).pipe(withLatestFrom(this.configuration$), switchMap(([searchTerm, configuration]) => {
            if (searchTerm.length < 1)
                return of([]);
            return fromFetch(HEREGeocoder.autocompleteurl(searchTerm, configuration), {
                headers: {
                    Accept: "application/json",
                },
            }).pipe(switchMap((response) => {
                if (response.ok) {
                    // OK return data
                    return response.json();
                }
                else {
                    // Server is returning a status requiring the client to try something else.
                    return throwError(`Error ${response.statusText}`);
                }
            }), map((json) => {
                const res = [];
                if (Object.hasOwnProperty.call(json, "items")) {
                    for (const data of json.items) {
                        if ([
                            "administrativeArea",
                            "locality",
                            "street",
                            "intersection",
                            "addressBlock",
                            "houseNumber",
                            "postalCodePoint",
                            "place",
                        ].indexOf(data.resultType) > 0) {
                            if (this._point_in_polygon([data.position.lng, data.position.lat])) {
                                const latlon = {
                                    lat: data.position.lat,
                                    lon: data.position.lng,
                                };
                                const _fillLocation = Location.createFromHERE(data, latlon);
                                res.push(_fillLocation);
                            }
                        }
                    }
                }
                return res;
            }), catchError((error) => {
                console.error(error);
                return of([]);
            }));
        }));
        return query$;
    }
    select(locationId) {
        const select$ = of(locationId).pipe(withLatestFrom(this.configuration$), switchMap(([locationId, configuration]) => {
            return fromFetch(HEREGeocoder.lookupurl(locationId, configuration), {
                headers: {
                    Accept: "application/json",
                },
            }).pipe(mergeMap((response) => {
                return response.json();
            }));
        }), map((json) => {
            const pos = {
                lat: json.position.lat,
                lon: json.position.lng,
            };
            return Location.createFromHERE(json, pos);
        }));
        return select$.toPromise();
    }
    _getDefaultConfiguration() {
        return {
            name: "here",
            autocompleteurl: "https://autosuggest.search.hereapi.com/v1/autosuggest",
            lookupurl: "https://lookup.search.hereapi.com/v1/lookup",
            commonparams: {
                lang: "de",
            },
            autocompleteparams: {
                limit: 10,
            },
            bbox: "bbox:-180,-90,180,90",
        };
    }
    static autocompleteurl(searchterm, configuration) {
        const in_param = configuration.circle || configuration.bbox;
        let searchparam = searchterm;
        if (configuration.addstring) {
            searchparam += " " + configuration.addstring;
        }
        const params = {
            ...{
                q: searchparam,
                in: in_param,
            },
            ...configuration.commonparams,
            ...configuration.autocompleteparams,
        };
        const params_str = Object.entries(params)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
        return `${configuration.autocompleteurl}?${params_str}`;
    }
    static lookupurl(locationid, configuration) {
        const parmas = {
            ...{
                id: locationid,
            },
            ...configuration.commonparams,
        };
        const parmas_str = Object.entries(parmas)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
        return `${configuration.lookupurl}?${parmas_str}`;
    }
    _point_in_polygon(point) {
        if (!this._boundingpolygon)
            return true;
        if (this._boundingpolygon.length == 0)
            return true;
        let odd = false;
        for (let i = 0, j = this._boundingpolygon.length - 1; i < this._boundingpolygon.length; i++) {
            if (this._boundingpolygon[i][1] > point[1] !== this._boundingpolygon[j][1] > point[1] &&
                point[0] <
                    ((this._boundingpolygon[j][0] - this._boundingpolygon[i][0]) *
                        (point[1] - this._boundingpolygon[i][1])) /
                        (this._boundingpolygon[j][1] - this._boundingpolygon[i][1]) +
                        this._boundingpolygon[i][0]) {
                odd = !odd;
            }
            j = i;
        }
        return odd;
    }
    set boundingpolygon(polygon) {
        this._boundingpolygon = polygon;
    }
    get boundingpolygon() {
        return this._boundingpolygon;
    }
}
//# sourceMappingURL=heregeocoder.js.map